// constants
import { PanelCategoryActionTypes } from './constants';
import { PanelCategory as PanelCategoryData } from 'src/types/panelCategory';

export type PanelCategoryActionType = {
    type:
        | PanelCategoryActionTypes.API_RESPONSE_SUCCESS
        | PanelCategoryActionTypes.API_RESPONSE_ERROR
        | PanelCategoryActionTypes.GET_PANEL_CATEGORY
        | PanelCategoryActionTypes.ADD_PANEL_CATEGORY
        | PanelCategoryActionTypes.EDIT_PANEL_CATEGORY
        | PanelCategoryActionTypes.GET_PANEL_CATEGORIES
        | PanelCategoryActionTypes.RESET
        | PanelCategoryActionTypes.RESET_SUCCESS
        | PanelCategoryActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const panelCategoryApiResponseSuccess = (
    actionType: string,
    data: PanelCategoryData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const panelCategoryApiResponseError = (
    actionType: string,
    data: PanelCategoryData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addPanelCategory = (params: any): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.ADD_PANEL_CATEGORY,
    payload: params,
});

export const editPanelCategory = (params: any): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.EDIT_PANEL_CATEGORY,
    payload: params,
});

export const getPanelCategory = (params: any): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.GET_PANEL_CATEGORY,
    payload: params,
});

export const getPanelCategories = (params: any): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.GET_PANEL_CATEGORIES,
    payload: params,
});

export const resetPanelCategory = (): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.RESET,
    payload: {},
});

export const resetPanelCategorySuccess = (): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetPanelCategoryError = (): PanelCategoryActionType => ({
    type: PanelCategoryActionTypes.RESET_ERROR,
    payload: {},
});
